import { Link } from 'react-router-dom'//npm install react-router-dom

function EventiItemAuth({ accettazione, dataInizio, dataFine, tipologia, titolo, img, comune, provincia, id, view }) {
    const imgArray = img.split(',')
    let data, opacity
    accettazione === 'null' ? opacity = '.5' : opacity = '1'

    if (dataInizio !== dataFine) {
        data = <p>Dal <b>{dataInizio.split("-").reverse().join("-")}</b> al <b>{dataFine.split("-").reverse().join("-")}</b></p>
    } else data = <p><b>{dataInizio.split("-").reverse().join("-")}</b></p>

    return (<>
        <div className="col">
            <div className="card" style={{ opacity: opacity }}>
                <Link to={{ pathname: `/eventiDetails/${id}` }} style={{ textDecoration: 'none' }}>
                    {img ? (
                        <img src={`https://leuro-bucket.s3.amazonaws.com/${imgArray[0]}`}className="card-img-top" />) :
                        (<img src={`https://leuro-bucket.s3.amazonaws.com/evento_senza_foto.jpg`} className="card-img-top" />)
                    }
                    <div className="card-body">
                        <h3 className="card-title"><b>{titolo}</b></h3>
                        {data}
                        <p>{comune.charAt(0).toUpperCase() + comune.slice(1)} ({provincia.toUpperCase()})
                        </p><br />
                        <p style={{
                            display: 'inline',
                            color: 'white',
                            backgroundColor: 'maroon',
                            width: 'max-content',
                            padding: '5px',
                        }}>{tipologia}
                        </p>
                        <span style={{ color: 'black', float: 'right' }}><i>View: {view}</i></span>

                        {accettazione === 'null' &&//EVENTO ANNULLATO SE ACCETTAZIONE E' 'NULL'
                            <p style={{
                                marginTop: '1rem',
                                textAlign: 'center',
                                backgroundColor: 'black',
                                color: 'white',
                                padding: '3px',
                                fontSize: 'x-large'
                            }}>Evento annullato
                            </p>}
                    </div>
                </Link>
            </div>
        </div>
    </>)
}
export default EventiItemAuth
